const isIE = !(
  window.navigator.userAgent.indexOf('MSE') === -1 &&
  window.navigator.userAgent.indexOf('Trident/') === -1
)

export default isIE
